import { render } from "./App.vue?vue&type=template&id=2ebf88e3"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\CloudSecOffice\\Documents\\myprojects\\Gravitas\\backend\\client_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__